import { yupResolver } from "@hookform/resolvers/yup";
import { bool, object, string } from "yup";

const editSchema = object({
  id: string().nullable(),
  customerActivated: bool(),
  email: string().email().required("E-mail is required"),
  firstName: string().nullable(),
  lastName: string().nullable(),
  roleName: string().nullable().required("Role is required"),
  phoneNumber: string().nullable(),
}).required();

const createSchema = object({
  customerActivated: bool(),
  email: string().email("Email is not valid").required("E-mail is required"),
  firstName: string().nullable(),
  lastName: string().nullable(),
  password: string().nullable().required("Password required"),
  roleName: string().nullable().required("Role is required"),
}).required();

export const editResolver = yupResolver(editSchema);

export const createResolver = yupResolver(createSchema);
